import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

const removeBootScreen = () => {
  const boot = document.getElementById("ibl-boot");
  if (!boot) return;
  // Remove directly on the next frame — skipping the opacity transition
  // avoids an extra style recalc/reflow during the LCP window.
  boot.remove();
};

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);

// Dismiss the static boot loader as soon as React has had a chance to paint.
// A single rAF is enough — the double rAF added ~16ms to LCP without any
// rendering benefit on modern browsers.
if (typeof window !== "undefined") {
  requestAnimationFrame(removeBootScreen);
}

// Defer non-critical font weights until after first paint so they don't
// block the initial render. These are needed for medium/bold body text,
// secondary headings and monospaced UI elements that appear below the fold.
if (typeof window !== "undefined") {
  const loadDeferredFonts = () => {
    void import("@fontsource/inter/500.css");
    void import("@fontsource/inter/600.css");
    void import("@fontsource/inter/700.css");
    void import("@fontsource/outfit/700.css");
    void import("@fontsource/jetbrains-mono/400.css");
  };
  if ("requestIdleCallback" in window) {
    (window as Window & { requestIdleCallback: (cb: () => void) => void }).requestIdleCallback(loadDeferredFonts);
  } else {
    setTimeout(loadDeferredFonts, 1500);
  }
}
